'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    padding: .25rem .75rem;\n    margin-bottom: 0.2rem;\n    border: 1px solid transparent;\n    border-radius: .25rem;\n    margin-top: 0.2rem;    \n    ', '\n'], ['\n    padding: .25rem .75rem;\n    margin-bottom: 0.2rem;\n    border: 1px solid transparent;\n    border-radius: .25rem;\n    margin-top: 0.2rem;    \n    ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../constants/colors');

var _opacity = require('../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _alignments = require('../../constants/alignments');

var _sizes = require('../../constants/sizes');

var _getColor = require('../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _bullet = require('../lists/bullet');

var _bullet2 = _interopRequireDefault(_bullet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AlertContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject, function (_ref) {
    var bgColor = _ref.bgColor,
        bgOpacity = _ref.bgOpacity,
        borderOpacity = _ref.borderOpacity;
    return '\n        background: ' + (0, _getColor2.default)(bgColor, bgOpacity) + ';\n        border-color: ' + (0, _getColor2.default)(bgColor, borderOpacity) + ';\n    ';
});

var Alert = function (_Component) {
    _inherits(Alert, _Component);

    function Alert(props) {
        _classCallCheck(this, Alert);

        var _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));

        _this.state = {
            currentTab: 0,
            hoverTab: null
        };
        return _this;
    }

    _createClass(Alert, [{
        key: 'render',
        value: function render() {
            var bgColor = _colors.Colors.Primary;
            var bgOpacity = _opacity2.default.Full;
            var borderOpacity = _opacity2.default.Dark;
            var headerColor = _colors.Colors.Primary;
            var textColor = _colors.Colors.PrimaryText;
            var textOpacity = _opacity2.default.None;

            switch (this.props.mode) {
                case 'info':
                    bgColor = _colors.Colors.Secondary;
                    bgOpacity = _opacity2.default.Lighter;
                    borderOpacity = _opacity2.default.Medium;
                    headerColor = _colors.Colors.SecondaryText;
                    textColor = _colors.Colors.SecondaryText;
                    textOpacity = _opacity2.default.None;
                    break;
                case 'success':
                    bgColor = _colors.Colors.Success;
                    bgOpacity = _opacity2.default.Lighter;
                    borderOpacity = _opacity2.default.Medium;
                    headerColor = _colors.Colors.SecondaryText;
                    textColor = _colors.Colors.SecondaryText;
                    textOpacity = _opacity2.default.None;
                    break;
                case 'danger':
                    bgColor = _colors.Colors.Error;
                    bgOpacity = _opacity2.default.VeryLight;
                    borderOpacity = _opacity2.default.Light;
                    headerColor = _colors.Colors.SecondaryText;
                    textColor = _colors.Colors.SecondaryText;
                    textOpacity = _opacity2.default.None;
                    break;
                case 'warning':
                    bgColor = _colors.Colors.Warning;
                    bgOpacity = _opacity2.default.VeryLight;
                    borderOpacity = _opacity2.default.Light;
                    headerColor = _colors.Colors.SecondaryText;
                    textColor = _colors.Colors.SecondaryText;
                    textOpacity = _opacity2.default.None;
                    break;

                default:
                    break;
            }

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    AlertContainer,
                    {
                        bgColor: bgColor,
                        bgOpacity: bgOpacity,
                        borderOpacity: borderOpacity },
                    this.props.header && _react2.default.createElement(_header2.default, { size: _sizes.Sizes.sm, textAlign: _alignments.Alignments.left, text: this.props.header, color: (0, _getColor2.default)(headerColor, textOpacity) }),
                    this.props.alert && _react2.default.createElement(_label2.default, { size: this.props.textSize || _sizes.Sizes.md, textAlign: _alignments.Alignments.left, text: this.props.alert, color: (0, _getColor2.default)(textColor, textOpacity) }),
                    this.props.items && _react2.default.createElement(_bullet2.default, { key: Math.random().toString(), size: this.props.textSize || _sizes.Sizes.md, references: this.props.items, color: (0, _getColor2.default)(textColor, textOpacity), top: _sizes.Sizes.xxs, bottom: _sizes.Sizes.xxs }),
                    this.props.children
                )
            );
        }
    }]);

    return Alert;
}(_react.Component);

Alert.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = Alert;